import { NavigationItemType } from './types';
import { findTopLevelActiveItem } from './useSidebarUtils';

/**
 * Provides derived navigation data for the sidebar and header menu.
 */
export const useSidebarNavigation = (pathname: string, isDesktop: boolean) => {
  /**
   * Returns header menu items for the active section (desktop only).
   */
  const getHeaderMenuData = (items: NavigationItemType[]): NavigationItemType[] => {
    const activeItem = findTopLevelActiveItem(items, pathname);

    if (!isDesktop || !activeItem?.children) return [];

    const process = (list: NavigationItemType[]): NavigationItemType[] =>
      list
        .map(item => {
          const isValid =
            (item.exceptionUrls || []).every(ex => !pathname.startsWith(ex)) ||
            (item.includeUrls || []).some(ex => pathname.startsWith(ex));
          if (isValid && item.isPageMenu) return item;
          if (isValid && item.children?.length) return process(item.children);
          return null;
        })
        .filter(Boolean)
        .flat() as NavigationItemType[];

    return process(activeItem.children);
  };

  return { getHeaderMenuData };
};
